import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { VenderMiniEntity } from '../../domain/entities/VenderMiniEntity'

export class VenderMiniModel extends VenderMiniEntity {
  constructor(dataDto: VenderMiniEntity) {
    super()
    mapEntityProperties<VenderMiniModel>(this, dataDto)
  }
}
